/**
 * Adds an alternate visibility rule to <product-sticky-add-to-cart>:
 * the sticky ATC is also shown BEFORE the user has scrolled to the main ATC button
 * (top of the page, form not yet in viewport). It hides while the form is in view,
 * then re-appears once the form has scrolled out (past it). The footer still hides it.
 *
 * We toggle the `is-form-outside` class on the sticky element based on whether the
 * observed form is in view, independently of the theme's own `is-visible` toggle.
 */
(() => {
  const init = () => {
    document.querySelectorAll('product-sticky-add-to-cart').forEach((sticky) => {
      if (sticky._stickyVisibilityBound) return;
      sticky._stickyVisibilityBound = true;

      const formId = sticky.getAttribute('main-product-form');
      const form = formId ? document.getElementById(formId) : null;
      const footer = document.querySelector('.shopify-section--footer');
      if (!form) return;

      let formInView = false;
      let footerInView = false;

      const update = () => {
        const shouldShow = !formInView && !footerInView;
        sticky.classList.toggle('is-form-outside', shouldShow);
      };

      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === form) formInView = entry.isIntersecting;
          if (entry.target === footer) footerInView = entry.isIntersecting;
        });
        update();
      }, { threshold: 0 }).observe(form);

      if (footer) {
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === footer) footerInView = entry.isIntersecting;
          });
          update();
        }, { threshold: 0 }).observe(footer);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
